<template>
  <div class="results__result" @click="handleClick">
    <div class="result__header">
      <div class="header__name">
        <div class="name__name">
          <span>{{ result.addressLine1 }}</span>
        </div>
        <div class="name__info" v-if="service === 'man'">
          <div class="info__icon icon-info-circle-before" ref="icon" @click.stop="toggleOverlay" @mouseenter="openOverlay" @mouseleave="closeOverlay"></div>
          <div class="info__overlay" :class="{ '-open': showInfoOverlay }" :style="overlayStyles">
            <ul class="-standard-list">
              <li>{{ $t('searchResults.result.info.service.default') }}</li>
              <li>{{ $t('searchResults.result.info.service.man') }}</li>
            </ul>
            <div class="overlay__shape" :style="overlayShapeStyles"></div>
          </div>
        </div>
      </div>
      <div class="header__meta">
        <div class="meta__service">
          <span>{{ $t('searchResults.result.service.' + service) }}</span>
        </div>
        <div class="meta__distance" v-if="distance">
          <span>{{ distance }} km</span>
        </div>
      </div>
    </div>
    <div class="result__content" v-if="!mobile">
      <div class="content__vehicle-types">
        <span>{{ divisions }}</span>
      </div>
      <div class="content__meta">
        <div class="meta-col">
          <div class="meta__location">
            <span>{{ result.postcode }} {{result.city}}, {{ result.country.id }}</span>
          </div>
          <div class="meta__phone">
            <span>{{ result.phone }}</span>
          </div>
        </div>
        <div class="meta-col">
          <div class="meta__opening" :class="{ '-has-open': opening.opened }">
            <span>{{ opening.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="result__content-mobile" v-if="mobile && !open">
      <div class="content__location">
        <span>{{ result.street }}, {{ result.postcode }} {{result.city}}, {{ result.country.id }}</span>
      </div>
      <div class="content__meta">
        <div class="meta__phone">
          <span>{{ result.phone }}</span>
        </div>
        <div class="meta__opening" :class="{ '-has-open': opening.opened }">
          <span>{{ opening.label }}</span>
        </div>
      </div>
    </div>
    <div class="result__content-mobile-open" v-if="mobile && open">
      <div class="content__location">
        <span>{{ result.street }}, {{ result.postcode }} {{result.city}}, {{ result.country.id }}</span>
      </div>
      <div class="content__opening" :class="{ '-has-open': opening.opened }">
        <span>{{ opening.label }}</span>
      </div>
      <div class="content__vehicle-types">
        <div class="vehicle-types__header">
          <span>{{ $t('searchResults.result.divisions') }}</span>
        </div>
        <div class="vehicle-types__content">
          <span>{{ divisions }}</span>
        </div>
      </div>
      <div class="content__meta">
        <div class="meta__header">
          <span>{{ $t('searchResults.result.meta.header') }}</span>
        </div>
        <div class="meta__content">
          <div class="meta__phone">
            <span>{{ result.phone }}</span>
          </div>
          <div class="meta__fax">
            <span>{{ result.fax }}</span>
          </div>
          <div class="meta__email">
            <a :href="`mailto:${result.email}`">
              <span>{{ $t('searchResults.result.meta.email') }}</span>
            </a>
          </div>
          <div class="meta__route">
            <a :href="`https://maps.google.de/?saddr=&daddr=${result.street}, ${result.postcode} ${result.city}, ${result.country.description}`">
              <span>{{ $t('searchResults.result.meta.route') }}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="content__link">
        <a :href="`${detailBase}${result.slug}/?brand=${brand}`" class="btn -btn-alpha">
          <span>{{ $t('searchResults.result.details') }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SearchResult',
  inject: ['detailBase', 'mobile'],
  data () {
    return {
      open: false,
      showInfoOverlay: false,
      overlayStyles: {},
      overlayShapeStyles: {}
    }
  },
  props: {
    result: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      brand: state => state.brand
    }),
    service () {
      return this.result.services.filter(service => service.id === 190).length ? 'man' : 'default'
    },
    distance () {
      return this.result.distance ? Math.round(this.result.distance) : null
    },
    divisions () {
      let divisions = ''
      this.result.divisions.forEach((division, index) => {
        divisions += division.description
        if (index + 1 !== this.result.divisions.length) divisions += ', '
      })
      return divisions
    },
    opening () {
      const now = new Date(new Date().toLocaleString('en-US', { timeZone: this.result.timezone }))
      const mainSeason = this.result.openings.main.filter(season => new Date(season.dateFrom) <= now && new Date(season.dateTo) >= now)
      const offSeason = this.result.openings.offSeason.filter(season => new Date(season.dateFrom) <= now && new Date(season.dateTo) >= now)
      const currentSeason = mainSeason.length ? mainSeason[0] : offSeason.length ? offSeason[0] : null
      let time = ''
      let label = 'notAvailable'
      let currentDay = now.getDay()
      const days = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday'
      ]
      if (currentSeason) {
        let determineOpening = true
        let count = 1
        const currentTime = (now.getHours() < 10 ? '0' + now.getHours() : now.getHours()) + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()) + ':' + (now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds())
        while (determineOpening && count <= 7) {
          const opening = currentSeason.schedule[days[currentDay]]
          if (opening.start.am && opening.stop.am) {
            if (now.getDay() === currentDay) {
              if (opening.start.am > currentTime) {
                determineOpening = false
                label = 'willOpen'
                time = opening.start.am
              } else if (opening.start.am <= currentTime && opening.stop.am >= currentTime) {
                determineOpening = false
                label = 'hasOpen'
                time = opening.stop.am
              } else if (opening.start.pm && opening.stop.pm) {
                if (opening.start.pm > currentTime) {
                  determineOpening = false
                  label = 'willOpen'
                  time = opening.start.pm
                } else if (opening.start.pm <= currentTime && opening.stop.pm >= currentTime) {
                  determineOpening = false
                  label = 'hasOpen'
                  time = opening.stop.pm
                }
              }
            } else {
              determineOpening = false
              label = 'willOpen'
              time = opening.start.am
            }
          }
          if (determineOpening) {
            currentDay = currentDay === 6 ? 0 : currentDay + 1
          }
          count++
        }
      }
      time = time ? time.split(':')[0] + ':' + time.split(':')[1] : ''
      const translation = this.$i18n.t('searchResults.result.openings.' + label + (label === 'willOpen' ? (now.getDay() === currentDay ? '.today' : ((currentDay - now.getDay() === 1) || (now.getDay() === 6 && currentDay === 0)) ? '.tomorrow' : ('.' + days[currentDay])) : ''), { time })
      return { opened: label === 'hasOpen', label: translation }
    }
  },
  methods: {
    handleClick () {
      if (this.mobile) {
        this.open = !this.open
      } else {
        window.location.href = this.detailBase + this.result.slug + '/?brand=' + this.brand
      }
    },
    toggleOverlay () {
      if (this.showInfoOverlay) {
        this.closeOverlay()
      } else {
        this.openOverlay()
      }
    },
    openOverlay () {
      // check if tooltip will overflow window
      const icon = this.$refs.icon
      const dimensions = icon.getBoundingClientRect()
      if (dimensions.left < (150 - (dimensions.width / 2))) {
        // if tooltip would overflow the window on the left side
        // lock the tooltip to the left window boundaries
        this.overlayStyles = { left: (dimensions.left * (-1)) + 'px' }
        this.overlayShapeStyles = { left: dimensions.left + 'px' }
      } else if (window.outerWidth - dimensions.left < (150 + (dimensions.width / 2))) {
        // if tooltip would overflow the window on the right side
        // lock the tooltip to the right window boundaries
        this.overlayStyles = { left: ((window.outerWidth - dimensions.left) - 300) + 'px' }
        this.overlayShapeStyles = { left: (300 - (window.outerWidth - dimensions.left)) + 'px' }
      }
      this.showInfoOverlay = true
    },
    closeOverlay () {
      this.overlayStyles = {}
      this.overlayShapeStyles = {}
      this.showInfoOverlay = false
    }
  }
}
</script>
